// extracted by mini-css-extract-plugin
export default {"baseButton":"BaseButton_baseButton__-p212"};